
export class CustomConstants {

    // Version
    public static ADMIN_SOFTWARE_VERSION: string = "v0.4.0";

    // Admin
    public static ADMIN_SOFTWARE_NAME: string = "My Grain Handler";
    public static ADMIN_SOFTWARE_ENDPOINT: string = "https://admin.my.grainhandler.com";
    // Monitoring
    public static MONITORING_SOFTWARE_URL: string = "https://my.grainhandler.com";

    // Backend
    public static API_ENDPOINT: string = "https://us-central1-jas-grain-handler.cloudfunctions.net/v2";
    public static SERVER_UIDS: string[] = [
        "jas-data-server",
        "jas-schedule-server",
        "jas-billing-server",
        "jot-server"
    ];

    // (Automatic billing)
    public static STRIPE_OEM_CONNECT_ID: string = "acct_1PVbgXP3ZJscofLS";

    // Return the stripe fee amount for a given price ID (100 = $1)
    public static getJASFeeForPriceID(priceID: string | null): number {
        // Always $150
        return (150 * 100);
    }

}
